import type { ReactNode, SelectHTMLAttributes, InputHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { cn } from './cn'

const baseField =
  'w-full rounded-xl border border-black/10 bg-tg-bg px-3 py-2.5 text-base text-tg-text outline-none focus:border-tg-link focus:ring-1 focus:ring-tg-link disabled:opacity-50'

export function Label({ children, htmlFor }: { children: ReactNode; htmlFor?: string }) {
  return (
    <label htmlFor={htmlFor} className="mb-1 block text-sm font-medium text-tg-text">
      {children}
    </label>
  )
}

export function FieldError({ children }: { children?: ReactNode }) {
  if (!children) return null
  return <p className="mt-1 text-xs text-risk-red">{children}</p>
}

export function Field({
  label,
  error,
  children,
}: {
  label?: ReactNode
  error?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="mb-4">
      {label && <Label>{label}</Label>}
      {children}
      <FieldError>{error}</FieldError>
    </div>
  )
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn(baseField, props.className)} />
}

export function Textarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={cn(baseField, 'min-h-[88px] resize-y', props.className)} />
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={cn(baseField, props.className)} />
}
